import { createContext } from 'react'

const campaignContext = createContext()

export default campaignContext
